import React from 'react';
import logo from "../assets/Header_Logo_BigTiny.png";

export default function Navbar(){
  return (
    <nav className="navbar navbar-expand-lg navbar-dark">
      <div className="container">
        <a className="navbar-brand d-flex align-items-center" href="/">
           <img src={logo} alt="Big Tiny Logo" className="logo" />
          <span className="ms-2 fw-semibold">Tiny Away</span>
        </a>
      </div>
    </nav>
  );
}
